import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["images", "imgs"];
import React, { useMemo } from 'react';
import classnames from 'classnames';
import './index.less';
const Picture = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs
  } = props;

  const {
    images = [],
    imgs = []
  } = attrs,
        others = _objectWithoutProperties(attrs, _excluded);

  const cls = classnames({
    'components-picture-render': true
  });
  const data = useMemo(() => {
    const a = Array.isArray(images) ? images : [];
    const b = Array.isArray(imgs) ? imgs : [];
    const list = [...a, ...b];
    return list.filter(item => !!item);
  }, [images, imgs]);
  const items = data.map((item = '', index) => {
    const {
      imageUrl = item
    } = item;
    return /*#__PURE__*/React.createElement("img", {
      alt: "",
      className: "img",
      src: imageUrl
    });
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), items);
});
export default Picture;